import React from 'react';
import { Helmet } from 'react-helmet';
import './Vision.css';
import mission from '../../../Gemco-Website-Images/About-Us/vision.jpg';

const Vision = () => {
  return (
    <>
        <div className='wp_vision_wrap'>
            <div className="container wp_viison_content">
                <div className="wp_vision_text">
                    <h1>Our Vision</h1>
                    <p>To be recognised as the UAE's most trusted specialist MEP contractor —
                        known for technical excellence, reliable delivery, and long-term client
                        partnerships.</p>
                    <br />
                    <h1>Our Mission</h1>
                    <p>To deliver precision MEP installation and supply solutions that enhance project
                        value, meet the highest quality standards, and build lasting relationships with
                        every client.</p>
                </div>
                <div className="wp_vision_image">
                    <img src={mission} alt="Dubai Construction" />
                </div>
            </div>
        </div>
    </>
  )
}

export default Vision